import { secureRequest } from 'utils/request';

import { IFilter, IParsedFilters } from '../filters';
import React from 'react';

import { IDropdownOption } from 'office-ui-fabric-react';
import store from 'configureStore';

export type Branch = { id: number; name: string };
export type Depot = {
  id: number;
  name: string;
  Branch_id: number;
};
export type Route = {
  id: number;
  name: string;
  short_name: string;
  route_type: string;
};
export type Vehicle = {
  Depot_id: number;
  capacity: number;
  depotNumber: number;
  gosNomer: string;
  id: number;
  isOnline: boolean;
  model: string;
  routeType: string;
  route_id: null | number;
  branch: number | undefined;
  center: string;
};

export type FormValues = {
  branch: number[];
  route: number[];
  vehicle: number[];
  routeType: string[];
  gosNomer: number[];
};

export type FiltersList = {
  branches: Branch[];
  depots: Depot[];
  routes: Route[];
  vehicles: Vehicle[];
  date: string | null;
};

export type ParsedFilters = {
  branches: IDropdownOption[];
  depots: IDropdownOption[];
  routes: IDropdownOption[];
  vehicles: IDropdownOption[];
  transporttypes: IDropdownOption[];
  gosNomer: IDropdownOption[];
};

type FiltersContext = {
  parsedFilters: IParsedFilters;
  filters: IFilter;
};

export const initialFilters: IFilter = {
  routes: [],
  depots: [],
  branches: [],
  vehicles: [],
};

export const initialParsedFilters: IParsedFilters = {
  branch: [],
  depot: [],
  depotNumber: [],
  gosNomer: [],
  model: [],
  routeType: [],
  route: [],
};

export const filtersContext = React.createContext<FiltersContext>({
  filters: initialFilters,
  parsedFilters: initialParsedFilters,
});

export const getMobileFilters = async () => {
  const filters = await secureRequest<FiltersList>(
    '/api/v1/map/mobile/filters'
  );
  if (filters) {
    const parsedFilters: ParsedFilters = {
      branches: [],
      depots: [],
      routes: [],
      vehicles: [],
      transporttypes: [],
      gosNomer: [],
    };

    filters.vehicles.forEach((vehicle) => {
      const depot = filters.depots.find(
        (depot) => vehicle.Depot_id === depot.id
      );
      vehicle.branch = depot ? depot.Branch_id : undefined;
      vehicle.model = vehicle.model || '';
    });

    const parseFilters = <T extends { id: number; name: string }>(
      filter: T
    ) => ({
      ...filter,
      key: filter.id,
      text: filter.name,
      primaryField: filter.name,
    });

    // parsedFilters.transporttypes = this.props.transporttypes.map((ttype) => ({
    //   ...ttype,
    //   key: ttype.code,
    //   text: ttype.title,
    //   primaryField: ttype.title,
    // }));

    parsedFilters.routes = filters.routes.map((route) =>
      parseFilters<Route>(route)
    );
    parsedFilters.branches = filters.branches.map((branch) =>
      parseFilters<Branch>(branch)
    );
    parsedFilters.depots = filters.depots.map((depot) =>
      parseFilters<Depot>(depot)
    );
    parsedFilters.vehicles = filters.vehicles.map((vehicle) => ({
      ...vehicle,
      text: vehicle.depotNumber ? vehicle.depotNumber.toString() : '',
      key: vehicle.id,
      primaryField: vehicle.depotNumber ? vehicle.depotNumber.toString() : '',
    }));
    parsedFilters.gosNomer = filters.vehicles.map((vehicle) => ({
      ...vehicle,
      text: vehicle.gosNomer ? vehicle.gosNomer.toString() : '',
      key: vehicle.id,
      primaryField: vehicle.gosNomer ? vehicle.gosNomer.toString() : '',
    }));

    parsedFilters.transporttypes = store
      .getState()
      .user.transporttypes.map(({ code, color, title }) => ({
        text: title,
        key: code,
        primaryField: title
      }));

    return { filters, parsedFilters };
  }
  return null;
};
